<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" title="Volver" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button class="btn btn-outline-success" *ngIf="entidadAuditora.Id > 0" type="button" title="Nueva Campaña"  (click)="onAddCampania()"><i class="fa fa-file-o"></i> Nueva Campaña </button>
            <button class="btn btn-outline-success" *ngIf="entidadAuditora.Id > 0" type="button" title="Nuevo Técnico" (click)="onAddTecnico()"><i class="fa fa-file-o"></i> Nuevo Técnico</button>
            <button *ngIf="!visibilitySpinner" type="button" (click)="onSave()" class="btn btn-outline-success" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">

        <h4>{{editTitle}} Entidad Auditora</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsedEntidad = !isCollapsedEntidad"
                       [attr.aria-expanded]="!isCollapsedEntidad" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Datos Principales
                            <i *ngIf="isCollapsedEntidad" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedEntidad" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>

                    <div class="card-body">

                        <div class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpNIF">NIF/NIE Representante</label>
                                <input formControlName="NIF" name="NIF" title=""
                                       class="form-control" id="inpNombre" type="text" value="" [ngClass]="displayFieldCss('NIF')" maxlength="9">

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NIF','required')">
                                    NIF/NIE Representante es obligatorio
                                </div>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NIF','NIF')">
                                    Formato de NIF incorrecto
                                </div>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NIF','NIF_duplicated')">
                                    El NIF ya existe en la base de datos
                                </div>
                            </div>


                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpNombre">Nombre Representante</label>
                                <input formControlName="Nombre" name="Nombre" title=""
                                        class="form-control" id="inpNombre" type="text" value="" [ngClass]="displayFieldCss('Nombre')" maxlength="50">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Nombre','required')">
                                    Nombre Representante es obligatorio
                                </div>
                            </div>


                            <div class="form-group col-md-6">
                                <label class="col-form-label required-field" for="inpApellidos">Apellidos Representante</label>
                                <input formControlName="Apellidos" name="Apellidos" title=""
                                        class="form-control" id="inpApellidos" type="text" value="" [ngClass]="displayFieldCss('Apellidos')" maxlength="150">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Apellidos','required')">
                                    Apellidos Representante es obligatorio
                                </div>
                            </div>

                        </div>

                        <div class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpNIFRazonSocial">NIF Razón Social</label>
                                <input formControlName="NIFRazonSocial" name="NIFRazonSocial" title=""
                                       class="form-control" id="inpNIFRazonSocial" type="text" value="" [ngClass]="displayFieldCss('NIFRazonSocial')" maxlength="9">

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('NIFRazonSocial','required')">
                                    NIF Razón Social es obligatorio
                                </div>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NIFRazonSocial','NIF')">
                                    Formato de NIF incorrecto
                                </div>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NIFRazonSocial','NIFRazonSocial_duplicated')">
                                    El NIF ya existe en la base de datos
                                </div>
                            </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label required-field" for="inpRazonSocial">Razón Social</label>
                                    <input formControlName="RazonSocial" name="RazonSocial" title=""
                                           class="form-control" id="inpNombre" type="text" value="" [ngClass]="displayFieldCss('RazonSocial')" maxlength="80">
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('RazonSocial','required')">
                                        Razón Social es obligatorio
                                    </div>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label required-field" for="inpLocalidadRazonSocial">Localidad Razón Social</label>
                                    <input formControlName="LocalidadRazonSocial" name="LocalidadRazonSocial" title=""
                                           class="form-control" id="inpLocalidadRazonSocial" type="text" value="" [ngClass]="displayFieldCss('LocalidadRazonSocial')" maxlength="100">

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('LocalidadRazonSocial','required')">
                                        Localidad Razón Social Representante es obligatorio
                                    </div>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label required-field" for="intProvincia">Provincia Razón Social</label>
                                    <ng-select loadingText="Cargando..."
                                               [items]="listProvincia"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdProvinciaRazonSocial"
                                               [readonly]="!listProvincia || listProvincia.length === 0"
                                               [loading]="!listProvincia || listProvincia.length === 0"
                                               notFoundText="Provincia no encontrada"
                                               [ngClass]="displayFieldCssNgSelect('IdProvinciaRazonSocial')"
                                               placeholder="-- Seleccione una Provincia --"
                                               clearAllText="Eliminar selección">
                                    </ng-select>
                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdProvinciaRazonSocial','required')">
                                        Provincia Razón Social  es obligatorio
                                    </div>
                                </div>

                            </div>

                        <div class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpCodigoPostalRazonSocial">Código Postal Razón Social</label>
                                <input formControlName="CodigoPostalRazonSocial" name="CodigoPostalRazonSocial" title="" numbersOnly
                                       class="form-control" id="inpCodigoPostalRazonSocial" type="text" value="" [ngClass]="displayFieldCss('CodigoPostalRazonSocial')" maxlength="5">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('CodigoPostalRazonSocial','required')">
                                    Código Postal Razón Social es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-9">
                                <label class="col-form-label required-field" for="inpDireccionRazonSocial">Dirección Razón Social</label>
                                <input formControlName="DireccionRazonSocial" name="DireccionRazonSocial" title=""
                                       class="form-control" id="inpDireccionRazonSocial" type="text" value="" [ngClass]="displayFieldCss('DireccionRazonSocial')" maxlength="180">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('DireccionRazonSocial','required')">
                                    Dirección Razón Social Representante es obligatorio
                                </div>
                            </div>
                        </div>

                        <div class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpNombrePersonaContacto">Nombre Persona Contacto</label>
                                <input formControlName="NombrePersonaContacto" name="NombrePersonaContacto" title=""
                                       class="form-control" id="inpNombrePersonaContacto" type="text" value="" [ngClass]="displayFieldCss('NombrePersonaContacto')" maxlength="50">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('NombrePersonaContacto','required')">
                                    Nombre Persona Contacto es obligatorio
                                </div>
                            </div>


                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpNombrePersonaContacto">Apellidos Persona Contacto</label>
                                <input formControlName="ApellidosPersonaContacto" name="ApellidosPersonaContacto" title=""
                                       class="form-control" id="inpApellidos" type="text" value="" [ngClass]="displayFieldCss('ApellidosPersonaContacto')" maxlength="150">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('ApellidosPersonaContacto','required')">
                                    Apellidos Persona Contacto es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpTelefonoPersonaContacto">Teléfono Persona Contacto</label>
                                <input formControlName="TelefonoPersonaContacto" name="TelefonoPersonaContacto" title=""
                                       class="form-control" id="inpTelefonoPersonaContacto" type="text" [ngClass]="displayFieldCss('TelefonoPersonaContacto')" value="" maxlength="20">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('TelefonoPersonaContacto','required')">

                                    Teléfono Persona Contacto es obligatorio
                                </div>

                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpEmailPersonaContacto">Email Persona Contacto</label>
                                <input formControlName="EmailPersonaContacto" name="EmailPersonaContacto" title=""
                                       class="form-control" id="inpEmailPersonaContacto" type="text" [ngClass]="displayFieldCss('EmailPersonaContacto')" value="" maxlength="50">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('EmailPersonaContacto','required')">

                                    Email Persona Contacto es obligatorio
                                </div>

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('EmailPersonaContacto','email')">
                                    Formato incorrecto
                                </div>
                            </div>

                        </div>

                        <div class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpActivo">Activa</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="Activa" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                offIcon="pi pi-times"></p-toggleButton>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpFechaAlta">Fecha Alta</label>
                                <p-calendar formControlName="FechaAlta" inputStyleClass="form-control"
                                            [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>
                            </div>


                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpFechaBaja">Fecha Baja</label>
                                <p-calendar formControlName="FechaBaja" inputStyleClass="form-control"
                                            [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>
                            </div>

                        </div>

                        <div class="row">

                            <div class="form-group col-md-12">
                                <label class="col-form-label" for="inpObservaciones">Observaciones</label>
                                <textarea style="resize:none" formControlName="Observaciones" name="Observaciones" title=""
                                          class="form-control" id="inpObservaciones" type="text" value="" maxlength="5000"></textarea>
                            </div>


                        </div>

                    </div>
                </div>
            </div>
        </div>
        
        <div class="row">
            <!--CAMPAÑAS-->
            <div class="col-md-6">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-header-buscador">
                        <i class="fa fa-plus"></i> <strong id="stAduana">Campañas Autorizadas</strong>
                        <label class="col-form-label" for="stCampania"></label>
                    </div>
                    <div class="card-body-detalle-list">

                        <div class="row">

                            <div class="col-md-12">

                                <table class="table table-list table-responsive table-sm">
                                    <thead>
                                        <tr>
                                            <th class="cabecerasTablaDetalles col-md-2"></th>
                                            <!--<th class="cabecerasTablaDetalles"></th>-->
                                            <th class="cabecerasTablaDetalles col-md-8">Nombre</th>
                                            <th class="cabecerasTablaDetalles col-md-2">Activa</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of entidadAuditora.TwRegCampaniaEntidadAuditoraCollection">

                                            <td scope="col" class="col-md-2">
                                                <div class="btn-group">
                                                    <button type="button" (click)="onEditCampania(item)" title="Editar"
                                                            class="btn btn-sm btn-info">
                                                        <i class="fa fa-search"></i>
                                                    </button>
                                                </div>
                                                <!--RDLF: en principio no se borran campañas, se 'desactivan'-->
                                                <!--<div class="btn-group">
                                                    <button type="button" (click)="onDeleteCampania(item)"
                                                            class="btn btn-sm btn-danger">
                                                        <i class="fa fa-remove"></i>
                                                    </button>
                                                </div>-->
                                            </td>

                                            <td scope="col" class="col-md-8">{{item.IdCampaniaDescripcion}}</td>
                                            <td scope="col" class="col-md-2">{{item.Activa | siNo}}</td>

                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <!--TECNICOS-->
            <div class="col-md-6">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-header-buscador">
                        <i class="fa fa-plus"></i> <strong id="stAduana">Técnicos Autorizados</strong>
                        <label class="col-form-label" for="stTecnico"></label>
                    </div>
                    <div class="card-body-detalle-list">

                        <div class="row">

                            <div class="col-md-12">
                                <table class="table table-list table-responsive table-sm">
                                    <thead>
                                        <tr>
                                            <th class="cabecerasTablaDetalles col-md-2"></th>
                                            <!--<th class="cabecerasTablaDetalles"></th>-->
                                            <th class="cabecerasTablaDetalles col-md-3">DNI</th>
                                            <th class="cabecerasTablaDetalles col-md-5">Nombre</th>
                                            <th class="cabecerasTablaDetalles col-md-2">Activo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of entidadAuditora.TwRegTecnicoEntidadAuditoraCollection">
                                            <td scope="col" class="col-md-2">
                                                <div class="btn-group">
                                                    <button type="button" (click)="onEditTecnico(item)" title="Editar"
                                                            class="btn btn-sm btn-info">
                                                        <i class="fa fa-search"></i>
                                                    </button>
                                                </div>
                                                <div class="btn-group" *ngIf="!item.FechaBaja">
                                                    <button type="button" (click)="onDeleteTecnicoExistenteComoACyEA(item)"
                                                            class="btn btn-sm btn-danger" title="Borrar Técnico de Entidad Auditora">
                                                        <i class="fa fa-remove"></i>
                                                    </button>
                                                </div>
                                                <div class="btn-group" *ngIf="item.FechaBaja">
                                                    <button type="button" (click)="onReactivateTecnicoExistenteComoACyEA(item)"
                                                            class="btn btn-sm btn-info" title="Reactivar Técnico de Entidad Auditora">
                                                        <i class="fa fa-check"></i>
                                                    </button>
                                                </div>
                                            </td>

                                            <td scope="col" class="col-md-3">{{item.NifUsuario}}</td>
                                            <td scope="col" class="col-md-5">{{item.NombreUsuario}} {{item.ApellidosUsuario}}</td>
                                            <td scope="col" class="col-md-2">{{item.Activo | siNo}}</td>

                                        </tr>

                                    </tbody>
                                </table>
                                <!--</div>

                        </div>-->
                            </div>
                        </div>

                    </div>
                </div>

            </div>



        </div>

    </div>


</form>
